function createLegFromTruckFreight(truckRecord: any) {
  const { truckFreight } = truckRecord;
  if (!truckFreight || typeof truckFreight !== "object") {
    return [];
  }

  const newLeg = {
    mode: "TRUCK",
    fscRateUom:
      "fscRate" in truckFreight && truckFreight.fscRate !== null ? "%" : null,
    route: null,
    rate: "rate" in truckFreight ? truckFreight.rate : null,
    distUom:
      "totalMiles" in truckFreight && truckFreight.totalMiles !== null
        ? "MI"
        : null,
    exp: truckFreight.expiration ? { ...truckFreight.expiration } : null,
    fscRate: "fscRate" in truckFreight ? truckFreight.fscRate : null,
    dist: "totalMiles" in truckFreight ? truckFreight.totalMiles : null,
    fsc: "fsc" in truckFreight ? truckFreight.fsc : null,
    curr: "curr" in truckFreight ? truckFreight.curr : null,
    rateUom: "uom" in truckRecord ? truckRecord.uom : null,
    costPerMile:
      "costPerMile" in truckFreight
        ? Number(truckFreight.costPerMile).toFixed(2)
        : null,
  };
  return [newLeg];
}

// TODO: replace with actual comp analysis used in the code rather than converting to the old format
// TODO: get rid of indication stuff by putting Gehads new stuff in there
export default function convertCompAnalysisTruckData(
  // truckRecordsArray: ICompAnalysisTruck[]
  truckRecordsArray: any[],
) {
  if (!Array.isArray(truckRecordsArray)) {
    console.error("Input must be an array of truckRecords.");
    return [];
  }

  return truckRecordsArray.map((truckRecord) => {
    const record = {
      origin: {
        name: truckRecord.origin?.name ?? null,
        owner: truckRecord.origin?.owner ?? null,
        id: truckRecord.origin?.id ?? null,
        coordinate: truckRecord.origin?.coordinate ?? null,
        city: truckRecord.origin?.city ?? null,
      },
      destination: {
        name: truckRecord.destination?.name ?? null,
        owner: truckRecord.destination?.owner ?? null,
        id: truckRecord.destination?.id ?? null,
        coordinate: truckRecord.destination?.coordinate ?? null,
        city: truckRecord.destination?.city ?? null,
      },
      price: truckRecord.maxPrice ?? 0,
      initialOffer: (truckRecord.maxPrice ?? 0) + (truckRecord.freight ?? 0),
      occPartyName: truckRecord.occupant?.name ?? null,
      // eslint-disable-next-line no-nested-ternary
      occupantTypes: truckRecord.competitor ? ["Competitor"] : ["Koch"],
      mode: "TRUCK",
      legs: [...createLegFromTruckFreight(truckRecord)],
      fees: 0,
      rate: null,
      rateFactor: null,
      distance: null,
      freight: truckRecord.freight !== undefined ? truckRecord.freight : null,
      isValid: false,
      minPrice: truckRecord.minPrice,
      maxPrice: truckRecord.maxPrice,
      dateLogged: truckRecord.indication?.dateLogged ?? null,
      comments:
        truckRecord.indication?.comments !== undefined
          ? truckRecord.indication.comments
          : "",
      shipWindowEndDate: truckRecord.indication?.shipWindowEndDate ?? null,
      contact: truckRecord.indication?.contact ?? null,
      account: truckRecord.indication?.account ?? null,
      marketer: truckRecord.indication?.marketer ?? null,
      rateIssue: null,
      id: truckRecord.id !== undefined ? truckRecord.id : null,
    };

    return record;
  });
}
